import { authHeader } from '../_helpers'
import { http } from '@/_services/http.service'

/* Create account */
function post(dob, email, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ dob, email, password })
  };

  return fetch(`${process.env.VUE_APP_API_URL}/user/register`, requestOptions)
    .then(function (response) {
      return response.text().then(text => {
        const data = text && JSON.parse(text)
        if (!response.ok) {
          return Promise.reject(data.response)
        }
        return data
      })
    })
}

function editPassword(password) {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password: password })
  };

  return http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/password`, requestOptions)
          .then(response => response.json())
}

/* Get account information */
function get() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  }

  return http.fetch(`${process.env.VUE_APP_API_URL}/user`, options)
      .then(response => response.json())
}

/* Delete account */
function remove(reason) {
  const options = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({reason})
  }

  let url = `${process.env.VUE_APP_API_URL}/user/unregister`

  return http.fetch(url, options)
}
function getUnregisterReasons() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  }

  return http.fetch(`${process.env.VUE_APP_API_URL}/user/unregister`, options)
      .then(response => response.json())
}

export const accountService = {
  post,
  get,
  getUnregisterReasons,
  remove,
  editPassword
}
